import * as sentryExceptionsService from './initExceptionsService';
import * as mockSentryExceptionsService from './initMockExceptionsService';

const isProduction = process.env.NODE_ENV === 'production';

/**
 * @deprecated
 * Use ExceptionsService from @libjs-devtools/exceptions
 */
export const ExceptionsService = isProduction
  ? sentryExceptionsService
  : mockSentryExceptionsService;

export { Severity as SEVERITY } from './Severity';
